
import { ShoppingCart } from "lucide-react";
import { Button } from "./ui/button";
import { useCart } from "@/contexts/CartContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const CartButton = () => {
  const { items } = useCart();
  const navigate = useNavigate();
  const { user, setAuthModalOpen } = useAuth();

  const handleCartClick = () => {
    if (!user) {
      // Show auth modal if user is not logged in
      setAuthModalOpen(true);
      return;
    }
    
    // Navigate to cart if user is logged in
    navigate("/cart");
  };

  return (
    <Button
      onClick={handleCartClick}
      variant="ghost"
      className="relative h-10 w-10 p-0"
    >
      <ShoppingCart className="h-6 w-6 text-black" />
      {items.length > 0 && (
        <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-black text-[10px] text-white">
          {items.length}
        </span>
      )}
    </Button>
  );
};
